import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { AppService } from '../../app.service';
import { StoreIdService } from '../services/store-id.service';
import { PremiumService } from '../../loyalty/premium/premium.service';

export const loyaltySubscriptionsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const storeIdService = inject(StoreIdService);
  const premiumService = inject(PremiumService);
  const appService = inject(AppService);

  const appStatus = toObservable(appService.appInitStatus);

  return appStatus.pipe(
    filter((status) => status === 'COMPLETE'),
    map(() => {
      const hasSubscriptions = premiumService.subscriptions().length > 0;

      if (hasSubscriptions) {
        return true;
      } else {
        router.navigate([`/${storeIdService.getStorePathPrefix()}`]);
        return false;
      }
    })
  );
};
